import { useEffect, useState, useMemo } from "react";
import Loading from "../Loading";
import getAssetPath from "src/Utils/getAssetPath";

interface PreloadProps {
  children: React.ReactNode;
}

const Preload = ({ children }: PreloadProps) => {
  const [loading, setLoading] = useState(true);
  const [loadedItems, setLoadedItems] = useState(0);

  const assets = useMemo(
    () => [
      getAssetPath("/images/BG/BG_1.jpg"),
      getAssetPath("/images/BG/BG_2.jpg"),
      getAssetPath("/images/icons/product.png"),
      getAssetPath("/images/screen_1/animation_0.png"),
      getAssetPath("/images/screen_1/animation_1.png"),
      getAssetPath("/images/screen_1/animation_2.png"),
      getAssetPath("/images/screen_1/animation_3.png"),
      getAssetPath("/images/screen_1/animation_4.png"),
      getAssetPath("/images/screen_1/animation_5.png"),
      getAssetPath("/images/screen_12/TV%20Shop-0.jpg"),
      getAssetPath("/images/screen_12/TV%20Shop-1.jpg"),
      getAssetPath("/images/screen_12/TV%20Shop-2.jpg"),
      getAssetPath("/images/screen_12/TV%20Shop-3.jpg"),
      getAssetPath("/images/screen_12/TV%20Shop-4.jpg"),
    ],
    []
  );

  useEffect(() => {
    const handleLoad = () => {
      setLoadedItems((prev) => prev + 1);
    };

    const preloadAssets = () => {
      assets.forEach((asset) => {
        if (asset.endsWith(".mp4")) {
          const video = document.createElement("video");
          video.src = asset;
          video.preload = "auto";
          video.onloadeddata = handleLoad;
        } else {
          const img = new Image();
          img.src = asset;
          img.onload = handleLoad;
        }
      });
    };

    preloadAssets();
  }, [assets]);

  useEffect(() => {
    if (loadedItems === assets.length) {
      setLoading(false);
    }
  }, [loadedItems, assets]);

  return <>{loading ? <Loading /> : <>{children}</>}</>;
};

export default Preload;
